import React, { useState, useEffect, useCallback, useRef } from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import OldHome from './pages/OldHome'
import CDTOne from './pages/CdtOne';
import Essay from './pages/Essay';
import PageNotFound from './pages/PageNotFound';
import { Routes, Route, useLocation } from 'react-router-dom';

function App() {
  const location = useLocation();
  const circleContainer = useRef(null);
  const [hideMouse, setHideMouse] = useState(false)
  const circle = useRef(null);
  const circle2 = useRef(null);

  //Mouse Icon Animations

  const growMouse = useCallback(() => {
    if (circle.current && circle2.current) {
      circle.current.style.opacity = 0;
      circle2.current.style.opacity = .75;
      circle.current.style.transform = 'scale(1.25)';
      circle2.current.style.transform = 'scale(1.5)';
    }
  }, [circle, circle2])

  const shrinkMouse = useCallback(() => {
    if (circle.current && circle2.current) {
      circle.current.style.opacity = 1;
      circle2.current.style.opacity = 0;
      circle.current.style.transform = 'scale(1)';
      circle2.current.style.transform = 'scale(1)';
    }
  }, [circle, circle2])

  const leftWindow = useCallback(() => {
    console.log('leave')
    circle.current.style.opacity = 0;
    circle2.current.style.opacity = 0;
    setHideMouse(true)
  }, [circle, circle2])

  const enterWindow = useCallback(() => {
    console.log('enter')
    circle.current.style.opacity = 1;
    circle2.current.style.opacity = 0;
    setHideMouse(false)
  }, [circle, circle2])

  //Mouse Events

  useEffect(() => {
    setTimeout(() => {
      shrinkMouse();
    }, 200)
  }, [location, shrinkMouse]);

  useEffect(() => {
    var xMousePos = 0;
    var yMousePos = 0;

    const setIconPos = () => {
      circleContainer.current.style.transform = 'translate3d(' + xMousePos + 'px ,' + yMousePos + '%, 0)';
    }

    const onMove = (e) => {
      xMousePos = e.pageX;
      yMousePos = (e.pageY - document.documentElement.scrollTop) / window.innerHeight * 100;
      if (circle.current && circle2.current) {
        setIconPos();
      }

      // if (yMousePos > 95 || yMousePos < 5){
      //   leftWindow();
      // }
      // else if(hideMouse){
      //   enterWindow()
      // }

      // if (xMousePos > window.innerWidth - 10 || xMousePos < 10){
      //   leftWindow();
      // }
      // else if (hideMouse){
      //   enterWindow()
      // }
    }

    const links = document.getElementsByTagName('a');

    if (!navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)/i)) {
      document.addEventListener('mousemove', onMove);
      for (var link of links) {
        link.addEventListener("mouseenter", growMouse);
        link.addEventListener("mouseleave", shrinkMouse);
      }
    }
    else {
      document.documentElement.style.cursor = "auto";
      for (var linkNormal of links) {
        linkNormal.style.cursor = "pointer";
      }
    }
  }, [location, growMouse, shrinkMouse])

  return (
    <div>
      <div className='circle-container' ref={circleContainer}>
        <i id="circle" ref={circle} />
        <i id="circle2" ref={circle2} />
      </div>
      <Routes>
        <Route index element={<OldHome />} />
        <Route path="/cdt-work-sample-1" element={<CDTOne />} />
        <Route path="/essays" element={<OldHome />} />
        <Route path="/essays/:id" element={<Essay />} />
        <Route path="/resources" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
